export const MODEL_NAME = 'marketingMetrics';
